export default "__VITE_ASSET__B2BCF36k__"